import React from "react"
import SvgIcon from "@mui/material/SvgIcon"

const ChefHatIcon = (props) => {
	return (
		<SvgIcon {...props} viewBox="0 0 24 24">
			<path d="M8.13 12H10.13V7H8.13V12ZM4.13 14V10.5C3.36333 10.1167 2.755 9.56267 2.305 8.838C1.855 8.11333 1.63 7.32567 1.63 6.475C1.63 5.225 2.05933 4.16667 2.918 3.3C3.77667 2.43333 4.83067 2 6.08 2C6.28 2 6.48433 2.01667 6.693 2.05C6.90167 2.08333 7.10567 2.125 7.305 2.175C7.72167 1.49167 8.26333 0.958333 8.93 0.575C9.59667 0.191667 10.33 0 11.13 0C11.93 0 12.6633 0.191667 13.33 0.575C13.9967 0.958333 14.5383 1.49167 14.955 2.175C15.155 2.125 15.355 2.08333 15.555 2.05C15.755 2.01667 15.9633 2 16.18 2C17.43 2 18.4843 2.43333 19.343 3.3C20.2017 4.16667 20.6307 5.225 20.63 6.475C20.63 7.325 20.405 8.11267 19.955 8.838C19.505 9.56333 18.8967 10.1173 18.13 10.5V14H4.13ZM12.13 12H14.13V7H12.13V12ZM4.13 20V16H18.13V20H4.13Z" transform="translate(1.5, 2) scale(0.95)" />
		</SvgIcon>
	)
}

export default ChefHatIcon
